import { c as _c } from "react/compiler-runtime";
const Duration = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 5c10.493 0 19 8.507 19 19s-8.507 19-19 19S5 34.493 5 24 13.507 5 24 5zm0 4C15.716 9 9 15.716 9 24c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm2 2.476v13.925l-10.146 3.691-1.368-3.759L22 22.6V11.476h4z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Duration;